import { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { useTranslation } from "react-i18next";
import { getLocale } from "~/lib/i18n.server";
import { createMeta, getMetaData } from "~/lib/utils";

export const meta: MetaFunction = (data: any) => {
  const { t } = useTranslation();
  return getMetaData(null, {
    title: t("Metodi di pagamento"),
    description: t(
      "Paga in tutta comodità e sicurezza. Scopri le modalità di pagamento accettate da Chorus Wellness: carte di credito, bancomat e altri sistemi digitali per la tua massima convenienza."
    ),
  });
};

export async function loader({ context, request }: LoaderFunctionArgs) {
  try {
    const pageSlug = "modalita-di-pagamento";

    const locale = await getLocale(request);
    const lang = locale;
    const res = await fetch(
      `${context.cloudflare.env.WP_API_HOST}/wp-json/wp/v2/pages?slug=${pageSlug}&lang=${lang}`
    );
    const pages: any = await res.json();
    if (!res.ok) {
      throw new Error(`Failed to fetch: ${res.statusText}`);
    }
    if (pages && pages.length > 0) {
      return {
        page: pages[0], 
        seo: pages[0]?.yoast_head_json,
        lang,
      };
    } else {
      return {
        error: "No pages found for the given slug.",
        page: {},
      };
    }
  } catch (err) {
    return {
      err: err,
      page: {},
    };
  }
}

export default function PaymentMethods() {
  const loaderData = useLoaderData<typeof loader>();
  const { t } = useTranslation();

  return (
    <div
      className={`
        relative
      `}
    >
      <main className="flex flex-col">
        {loaderData.page.acf?.hero && (
          <section>
            <div className="py-20 px-4">
              <div className="flex flex-col max-w-4xl mx-auto items-center justify-center">
                <h1 className="text-2xl lg:text-5xl text-secondary font-tenor-sans uppercase">
                  {loaderData.page.acf?.hero.title}
                </h1>
                <hr className="block w-16 h-[2px] bg-secondary mt-2" />
                <p className="text-secondary text-lg mt-4">
                  {loaderData.page.acf?.hero.description}
                </p>
              </div>
            </div>
          </section>
        )}

        {loaderData.page && loaderData.page.acf?.sections && (
          <section className="w-full lg:py-12 grid grid-cols-1 gap-12">
            {loaderData.page.acf?.sections.map(
              (section: any, index: number) => {
                return (
                  <div key={index} className="flex flex-col items-center">
                    <div className="flex flex-col w-full">
                      <h4 className="font-tenor-sans text-2xl text-secondary uppercase max-w-7xl w-full mx-auto px-4">
                        {section.title}
                      </h4>
                      <div className="bg-muted py-12 w-full mt-4">
                        <div className="grid grid-cols-2 lg:grid-cols-6 gap-4 max-w-7xl w-full mx-auto px-4">
                          {section.payment_methods?.map(
                            (paymentMethod: any, index: number) => {
                              return (
                                <div key={index} className=" ">
                                  <img
                                    alt=""
                                    src={`/cms-asset/${paymentMethod.image?.id}`}
                                    className="w-full h-52 object-cover object-center"
                                  />
                                  <span>{paymentMethod.title}</span>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </section>
        )}
      </main>
    </div>
  );
}
